import { CheckCircle, AlertCircle, Trash2 } from 'lucide-react';
import type { Installation } from '@/services/githubApi';

interface ConnectionStatusProps {
  installations: Installation[];
  onRemove: (installationId: number) => Promise<void>;
}

export function ConnectionStatus({ installations, onRemove }: ConnectionStatusProps) {
  if (installations.length === 0) {
    return (
      <div className="p-6 rounded-lg border border-dashed border-slate-300 dark:border-slate-700 text-center">
        <AlertCircle className="w-8 h-8 text-slate-400 mx-auto mb-3" />
        <p className="text-sm text-slate-600 dark:text-slate-400">
          No GitHub App installed. Connect your GitHub account to get started.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {installations.map((install) => (
        <div
          key={install.installation_id}
          className="flex items-center justify-between px-4 py-3 rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900"
        >
          <div className="flex items-center gap-3">
            <CheckCircle className="w-4 h-4 text-emerald-500" />
            <div>
              <p className="text-sm font-medium text-slate-900 dark:text-slate-100">
                {install.account_login}
              </p>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                {install.account_type} &middot; Connected {new Date(install.connected_at).toLocaleDateString()}
              </p>
            </div>
          </div>
          <button
            onClick={() => onRemove(install.installation_id)}
            className="p-1.5 rounded text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
            title="Remove installation"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
